/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LossOfProductionMetricVariantUpdateRequest
 */
export interface LossOfProductionMetricVariantUpdateRequest {
    /**
     * Unique uuid key mapping to an i18n entry
     * @type {string}
     * @memberof LossOfProductionMetricVariantUpdateRequest
     */
    name?: string;
    /**
     * List of generator keys for this variant
     * @type {Array<string>}
     * @memberof LossOfProductionMetricVariantUpdateRequest
     */
    generatorKeys?: Array<string>;
    /**
     * List of generator status keys of this variant
     * @type {Array<string>}
     * @memberof LossOfProductionMetricVariantUpdateRequest
     */
    generatorStatusKeys?: Array<string>;
}

/**
 * Check if a given object implements the LossOfProductionMetricVariantUpdateRequest interface.
 */
export function instanceOfLossOfProductionMetricVariantUpdateRequest(value: object): value is LossOfProductionMetricVariantUpdateRequest {
    return true;
}

export function LossOfProductionMetricVariantUpdateRequestFromJSON(json: any): LossOfProductionMetricVariantUpdateRequest {
    return LossOfProductionMetricVariantUpdateRequestFromJSONTyped(json, false);
}

export function LossOfProductionMetricVariantUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LossOfProductionMetricVariantUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'generatorKeys': json['generatorKeys'] == null ? undefined : json['generatorKeys'],
        'generatorStatusKeys': json['generatorStatusKeys'] == null ? undefined : json['generatorStatusKeys'],
    };
}

export function LossOfProductionMetricVariantUpdateRequestToJSON(json: any): LossOfProductionMetricVariantUpdateRequest {
    return LossOfProductionMetricVariantUpdateRequestToJSONTyped(json, false);
}

export function LossOfProductionMetricVariantUpdateRequestToJSONTyped(value?: LossOfProductionMetricVariantUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'generatorKeys': value['generatorKeys'],
        'generatorStatusKeys': value['generatorStatusKeys'],
    };
}

